module.exports = __webpack_public_path__ + "img/linkedin-logo.1b18d461.png";